import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {UsersService} from '../../../Services/users.service';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {TranslateService} from '@ngx-translate/core';
import { DealersService } from 'src/app/back-office/Services/dealers.service';
import { BroadcastService } from 'src/app/shared/Services/broadcast.service';
import { AuthenticationService } from 'src/app/shared/Services/authentication.service';

@Component({
  selector: 'app-system-users-overview',
  templateUrl: './system-users-overview.component.html',
  styleUrls: ['./system-users-overview.component.scss']
})
export class SystemUsersOverviewComponent implements OnInit {
  public grid: Grid;
  public dealerId: number;
  public collectionName: string;
  public disableDeleteButton = false;
  public disableDeactive2FAButton = false


  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('deactive2FAModal', {static: false}) deactive2FAModal = null;
  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;

  constructor(
    private router: Router, 
    private userService: UsersService, 
    private translateService: TranslateService,
    private dealersService: DealersService,
    private broadcastService: BroadcastService,
    private authService: AuthenticationService,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.user.fullName',
          prop: 'fullName',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.user.username',
          prop: 'username',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.user.phone',
          prop: 'phone',
          sortable: false,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.user.role',
          prop: 'role.name',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translateService.instant(row);
            }
          }
        },
        <TextColumn>{
          name: 'doctrine.user.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case SystemUser.SYSTEMUSER_ACTIVE:
                return this.translateService.instant('global.active');
              case SystemUser.SYSTEMUSER_INACTIVE:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => {
                if (this.authService.getUserName() === row.username) {
                  return this.router.navigate(['/', 'back-office', 'account-setting']);
                }
                return this.router.navigateByUrl('back-office/system-user/' + row.id);
              },
              showCallback: row => row,
              btnClass: 'ripple light me-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.dealerId = row.id;
                this.collectionName = row.fullName;
                this.deleteModal.show();
              },
              showCallback: row => {
                if (this.authService.getUserName() === row.username) return;
                return row;
              },
              btnClass: 'ripple light me-1'
            },
            <ActionItem>{
              icon: 'fa fa-ban fa-lg',
              tooltip: 'auth.2fa.deactivate',
              onclick: row => {
                this.dealerId = row.id;
                this.collectionName = row.fullName;
                this.deactive2FAModal.show();
              },
              showCallback: (row) => {
                if (row.isGoogleAuthenticatorEnabled) {
                  return row;
                }
                return;
              },
              btnClass: 'ripple light me-1'
            }
          ]
        }
      ],
      service: this.userService,
      rememberURL: this.router.url,
      method: 'getUsers',
      defaultSort: 'firstName',
      rowDetailTemplate: this.usersRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true
    };
  }

  public softDelete() {
    this.disableDeleteButton = true;
    this.dealersService.softDeleteBackoffice(this.dealerId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getUsers');
      this.deleteModal.hide();
      this.disableDeleteButton = false;
    });
  }

  public deactive2FA(){
    this.disableDeactive2FAButton = true;
    this.dealersService.deactivateDealer2FA(this.dealerId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getUsers');
      this.deactive2FAModal.hide();
      this.disableDeactive2FAButton = false;
    }); 
  }
}
